class Worldmap {
  constructor() {
    const worldmap = document.querySelector('#svg-worldmap');

    if (worldmap) {
      this.lastTrigger = false;
      this.lastTarget = false;
      this.lastHover = false;
      this.init(worldmap);
    }
  }

  init(worldmap) {
    const triggers = worldmap.querySelectorAll('[id*="trigger-"]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const number = this.getNumber(trigger.id);
        if (this.lastTrigger !== trigger) {

          if (this.lastTarget && this.lastTarget.classList.contains('visible')) {
            this.lastTarget.classList.remove('visible');
          }
          if (this.lastHover && this.lastHover.classList.contains('visible')) {
            this.lastHover.classList.remove('visible');
          }

          this.lastTarget = worldmap.querySelector('#target-' + number);
          if (this.lastTarget) {
            this.lastTarget.classList.add('visible');
          }

          this.lastHover = worldmap.querySelector('#hover-' + number);
          if (this.lastHover) {
            this.lastHover.classList.add('visible');
          }

          this.lastTrigger = trigger;
        } else {
          if (this.lastHover) {
            this.lastHover.classList.remove('visible');
          }
          if (this.lastTarget) {
            this.lastTarget.classList.remove('visible');
          }
          this.lastTrigger = false;
        }
        this.hideDots(worldmap);
      });
    });
  }


  hideDots(worldmap) {
    const dots = document.querySelector('#dots');
    //console.log(dots)
    if (!dots) return;

    const hasVisible = Array.from(worldmap.querySelectorAll('*')).some(element => element.classList.contains('visible'));

    if (hasVisible) {
      dots.classList.add('hide-dots');
    } else {
      dots.classList.remove('hide-dots');
    }
  }

  getNumber(string) {
    const arr = string.split('-');
    return arr[arr.length - 1];
  }
}


export default Worldmap;
